export default __webpack_public_path__ + "3bccba608bb74605a286cdca7f74bc02.mp3";